import { some, none} from '@danwang/option';
import type {Option} from '@danwang/option';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseJson = (input: string): Option<any> => {
  try {
    return some(JSON.parse(input));
  } catch {
    return none;
  }
};
